<template>
  <ValidationObserver ref="GemaWorksCheckDialog" v-slot="{ passes }">
    <BaseDialog
      :showDialog="showGemaWorksCheckDialog"
      maxDialogWidth="900"
      maxCardHeight="700"
      headline="lang_DASHBOARD_STATUS_CHECK_CWR_STATUS_CHECK"
      :close="close"
    >
      <template v-slot:dialogText>
          <v-container fluid>
            <v-row>           
              <v-col class="text-center" v-if="cwrStatusCheckShowButton">
                  <BaseButton 
                      @click="passes(cwrStatusCheck)"
                      :disabled="isCwrStatusCheckLoading"
                      label="lang_DASHBOARD_STATUS_CHECK_CWR_STATUS_CHECK" 
                  />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="hasCwrStatusCheckErrors || cwrStatusCheckProgress">
            <v-row 
              v-for="(row, index) in cwrStatusCheckErrors"
              class="justify-center mt-1 mb-2"
              :key="index"
            >
              <span v-html="row"></span>
            </v-row>
            <v-row class="justify-center mt-2 pl-0 ml-0 align-center">
              <span v-html="cwrStatusCheckProgress"></span>
              <BaseIcon 
                    v-if="cwrStatusCheckZipPath !== null && cwrStatusCheckZipPath !== ''"
                    @click.stop="downloadFile(cwrStatusCheckZipPath)" 
                    icon="cloud_download" 
                    :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                />
            </v-row>
          </v-container>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/_base/BaseDialog"
import BaseButton from "@/components/_buttons/BaseButton"
import BaseIcon from '@/components/_buttons/BaseIcon'
import i18n from '@/assets/i18n/i18n'
import api from '@/api_alv'

export default {
  name: "GemaWorksCheckDialog",
  components: {
    BaseDialog,
    BaseButton,
    BaseIcon,
  },
  data() {
    return {
      isCwrStatusCheckLoading: false,
      cwrStatusCheckProgress: '',
      cwrFinalResultOfFileLoop: '',
      cwrStatusCheckShowButton: true,
      cwrStatusCheckErrors: [],
      hasCwrStatusCheckErrors: false,
    };
  },
  computed: {
    cwrStatusCheckZipPath: { 
        get() {
            return this.$store.getters.getDashboardCwrStatusCheckZip 
        },
        set(value) {
            this.$store.commit('setDashboardCwrStatusCheckZip', value)
        }
    },
    showGemaWorksCheckDialog: {
      get() {
        return this.$store.getters.getShowGemaWorksCheckDialog;
      },
      set(showGemaWorksCheckDialog) {
        this.$store.commit(
          "setShowGemaWorksCheckDialog",
          showGemaWorksCheckDialog
        );
      },
    },
  },
  methods: {
    downloadFile(path) {
        console.log(path)
        api.getFileFromALV(path.response.path)
    },
    async cwrStatusCheck() {
        this.cwrStatusCheckZipPath = null
        this.isCwrStatusCheckLoading = true
        this.cwrStatusCheckProgress = this.$t("lang_GENERIC_CAPTION_ESTABLISHING_CONNECTION")
        let result = {}

        // 1) get list of files by society
        result = await this.$store.dispatch("cwrStatusCheckListOfFiles");

        if (result.error == 1) {
            let message = this.$t(result.errorMsg)
            this.$store.commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t(result.response.errorMsg),
            })
            this.cwrStatusCheckProgress = ""
            this.isCwrStatusCheckLoading = false
            return
        } 

        let societiesNoFiles = []
        let societiesWithFiles = []
        // 2) loop through societies
        while(result.response.length) {
            let element = result.response.shift()
            let metaData = element.metadata
            this.cwrStatusCheckProgress = "Checking: " + metaData.societyCode
            if (metaData.error == 1) {
                this.cwrStatusCheckProgress = this.$t(metaData.errorMsg)
                this.hasCwrStatusCheckErrors = true
                this.cwrStatusCheckErrors.push(`<b>${metaData.societyName}</b>: ${this.$t(metaData.errorMsg)}`)
            } else {
                // loop through files
                let listOfFiles = element.files
                let numOfFiles = listOfFiles.length
                if (numOfFiles == 0) {
                    societiesNoFiles.push(metaData.societyName)
                    this.cwrStatusCheckZipPath = null
                } else {
                    societiesWithFiles.push(metaData.societyName)
                    let index = 1
                    while(listOfFiles.length) { // keyword "await", below, only works with while() not with .forEach()
                        let fileName = listOfFiles.shift()
                        this.cwrStatusCheckProgress = this.$t("lang_GENERIC_CAPTION_PROCESSING") + " " + index + " " + this.$t("lang_GENERIC_CAPTION_FROM_LOWERCASE") + " " + numOfFiles + ": " + fileName
                        let resultPerFile = await this.$store.dispatch("cwrStatusCheck", {'metadata':metaData, 'filename':fileName})
                        this.cwrFinalResultOfFileLoop = resultPerFile
                        index++
                    }
                }
            }
        }

        if (societiesNoFiles.length) {
            let msg = `<b>${societiesNoFiles.join(', ')}</b>: ${this.$t("lang_GENERIC_MESSAGE_WARNING_NO_FILES_FOUND")}`
            this.cwrStatusCheckProgress = msg + '<br>'
        } else {
            this.cwrStatusCheckProgress = ''
        }

        if (this.cwrFinalResultOfFileLoop) {
            this.cwrStatusCheckZipPath = this.cwrFinalResultOfFileLoop
            this.cwrStatusCheckProgress += `<b>${societiesWithFiles.join(',')}</b>: ${this.$t("lang_GENERIC_CAPTION_DOWNLOAD_ZIP_REPORT")}`
        }

        return
    },
    close() {
      this.showGemaWorksCheckDialog = false
      this.cwrStatusCheckShowButton = true
      this.cwrFinalResultOfFileLoop = null
      this.isCwrStatusCheckLoading = false
      this.cwrStatusCheckProgress = ''
      this.cwrStatusCheckZipPath = null
      this.hasCwrStatusCheckErrors = false
      this.cwrStatusCheckErrors = []
    },
    async gemaSoundfile() {
      this.close()
      this.$store.commit('setShowGemaSoundfileDialog', true)
      let r = await this.$store.dispatch('checkGemaSoundfileCredentials')
      if(r.error == -1) {
          this.$store.commit('setShowGemaSoundfileDialog', true)
      } else {
          this.$store.commit('setSnackbar', {
              type: 'error',
              msg: i18n.t(r.response.errorMsg)
          })
      }
    }
  }
};
</script>